(() => {
  'use strict';
  if (window.StarfanDL) return;
  const configNode = document.getElementById('sf-datalayer-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const packages = new Set(['taraftar-yildizi', 'super-yildiz', 'premium-yildiz', 'vip-yildiz']);
  const lists = {
    paketler: 'Paketler', galatasaray_urunleri: 'Galatasaray Lisanslı Ürünler',
    home_paketler: 'Anasayfa Paketler', home_merch: 'Anasayfa Lisanslı Ürünler',
    upsell_customize: 'Yıldızınla birlikte tercih edilenler',
  };
  const memory = {};
  function read(key, fallback) {
    try { return JSON.parse(sessionStorage.getItem('sf_dl_' + key)) ?? fallback; }
    catch (_) { return memory[key] ?? fallback; }
  }
  function write(key, value) {
    memory[key] = value;
    try { sessionStorage.setItem('sf_dl_' + key, JSON.stringify(value)); } catch (_) {}
  }
  const debug = window.Shopify?.theme?.role === 'unpublished' &&
    (new URLSearchParams(location.search).get('sf_dl_debug') === '1' || read('debug', false));
  if (debug) write('debug', true);
  const round = value => Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  const listInfo = id => lists[id] ? { item_list_id: id, item_list_name: lists[id] } : {};
  const outgoing = [];
  let retryTimer = null;
  let attempts = 0;
  function flush() {
    retryTimer = null;
    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      if (attempts++ < 100) retryTimer = setTimeout(flush, 100);
      else {
        outgoing.length = 0;
        if (debug) console.warn('[StarfanDL] Shopify publish unavailable');
      }
      return;
    }
    attempts = 0;
    while (outgoing.length) {
      const payload = outgoing.shift();
      try {
        const result = window.Shopify.analytics.publish('starfan:datalayer', { payload });
        if (result?.catch) result.catch(() => {
          if (debug) console.warn('[StarfanDL] Shopify publish rejected');
        });
      } catch (_) {
        if (debug) console.warn('[StarfanDL] Shopify publish failed');
      }
    }
  }
  function emit(event, fields) {
    const payload = { event, ...fields };
    const snapshot = debug ? JSON.stringify(payload) : null;
    if (outgoing.length < 200) outgoing.push(payload);
    if (retryTimer === null) flush();
    if (debug) console.info('[StarfanDL publish queued] ' + snapshot);
  }
  function ecommerce(event, items, fields = {}, monetary = true) {
    if (!items.length) return;
    for (let offset = 0; offset < items.length; offset += 200) {
      const batch = items.slice(offset, offset + 200);
      const money = monetary ? {
        currency: config.currency,
        value: round(batch.reduce((sum, item) => sum + item.price * item.quantity, 0)),
      } : {};
      emit(event, { ecommerce: { ...money, ...fields, items: batch } });
    }
  }
  function item(product, variant, quantity = 1, source = {}) {
    const category = packages.has(product.handle) || (config.packageIds || []).some(id => String(id) === String(product.id))
      ? 'StarFan Paketi' : 'StarFan Merch';
    return {
      item_id: `shopify_TR_${product.id}_${variant.id}`,
      item_name: product.title, item_brand: 'StarFan', item_category: category,
      ...(category === 'StarFan Merch' && variant.title && variant.title !== 'Default Title'
        ? { item_variant: variant.title } : {}),
      price: round(variant.price / 100), quantity, index: 1, ...source,
    };
  }
  const safe = fn => (...args) => {
    try { return fn(...args); } catch (error) {
      if (debug) console.warn('[StarfanDL failure] ' + error.message);
    }
  };
  let productSource = {};
  const pending = read('selection', null);
  if (config.product && pending && pending.productId === String(config.product.id) &&
      Date.now() - pending.at < 30 * 60 * 1000 &&
      document.referrer === pending.from) {
    productSource = pending.source;
    write('selection', null);
  }
  let cartSources = read('cart_sources', {});
  function cartItems() {
    return config.cart.map((line, index) => ({
      ...line.item, index: index + 1, ...(cartSources[line.key] || {}),
    }));
  }
  function added(response, requested, sources = {}) {
    const rows = response.items || [response];
    const items = rows.map((row, index) => {
      const variantId = String(row.variant_id || row.id);
      const requestedRow = requested.find(x => String(x.id) === variantId);
      const source = sources[variantId] || (String(row.product_id) === String(config.product?.id) ? productSource : {});
      const responsePrice = row.final_price ?? row.price;
      // /cart/add returns decimal money strings; /cart/add.js returns integer cents.
      const cents = typeof responsePrice === 'string' ? Number(responsePrice) * 100 : responsePrice;
      const result = item({ id: row.product_id, title: row.product_title, handle: row.handle ||
        (String(row.product_id) === String(config.product?.id) ? config.product.handle : undefined) },
        { id: variantId, title: row.variant_title, price: cents },
        Number(requestedRow?.quantity || 1), { index: index + 1, ...source });
      if (row.key) cartSources[row.key] = source;
      return result;
    });
    write('cart_sources', cartSources);
    ecommerce('add_to_cart', items);
  }
  function upsell(products) {
    const entries = products.map((product, index) => {
      const variant = product.variants.find(v => v.available) || product.variants[0];
      return item(product, variant, 1, { ...listInfo('upsell_customize'), index: index + 1 });
    });
    ecommerce('view_upsell', entries, listInfo('upsell_customize'), false);
  }
  function removed(key) {
    const index = config.cart.findIndex(line => line.key === key);
    if (index < 0) return;
    ecommerce('remove_from_cart', [cartItems()[index]]);
    config.cart.splice(index, 1);
    delete cartSources[key];
    write('cart_sources', cartSources);
  }
  function error(type, message, where) {
    let text = String(message);
    document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea').forEach(input => {
      const value = input.value.trim();
      if (value.length >= 2) text = text.split(value).join('[gizli]');
    });
    const clean = text.replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/g, '[gizli]')
      .replace(/\b\d{6,}\b/g, '[gizli]').slice(0, 100);
    emit('site_error', { error_type: type, error_message: clean, error_location: where });
  }
  window.StarfanDL = {
    added: safe(added), upsell: safe(upsell), removed: safe(removed),
    skip: safe(() => emit('skip_upsell', listInfo('upsell_customize'))),
    checkout: safe(() => ecommerce('begin_checkout', cartItems())),
    error: safe(error),
  };
  const observed = new WeakSet();
  const signatures = new WeakMap();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { safe(viewList)(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.01 });
  function listItems(container) {
    return Array.from(container.querySelectorAll('[data-sf-dl-item]')).map((card, index) => ({
      ...JSON.parse(card.dataset.sfDlItem), ...listInfo(container.dataset.sfDlList), index: index + 1,
    }));
  }
  function viewList(container) {
    const entries = listItems(container);
    const signature = JSON.stringify(entries);
    if (signatures.get(container) === signature) return;
    signatures.set(container, signature);
    ecommerce('view_item_list', entries, listInfo(container.dataset.sfDlList), false);
  }
  function scanLists() {
    document.querySelectorAll('[data-sf-dl-list]').forEach(container => {
      if (!lists[container.dataset.sfDlList]) return;
      if (!observed.has(container)) {
        observed.add(container); observer.observe(container);
      } else if (signatures.has(container)) {
        const box = container.getBoundingClientRect();
        if (box.top < innerHeight && box.bottom > 0) safe(viewList)(container);
      }
    });
  }
  scanLists();
  new MutationObserver(scanLists).observe(document.getElementById('MainContent') || document.body,
    { childList: true, subtree: true });
  document.addEventListener('click', safe(event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const card = link.closest('[data-sf-dl-item]');
    const container = card?.closest('[data-sf-dl-list]');
    if (container && lists[container.dataset.sfDlList] && new URL(link.href).pathname.includes('/products/')) {
      const index = Array.from(container.querySelectorAll('[data-sf-dl-item]')).indexOf(card);
      const selected = listItems(container)[index];
      const source = { ...listInfo(container.dataset.sfDlList), index: index + 1 };
      write('selection', { productId: selected.item_id.split('_')[2], source, from: location.href, at: Date.now() });
      ecommerce('select_item', [selected], listInfo(container.dataset.sfDlList), false);
    }
    const name = link.textContent.trim();
    if (!name || !/^https?:/.test(link.href)) return;
    if (link.closest('.header__inline-menu, .menu-drawer__navigation, .sf-header__nav')) {
      emit('main_menu_click', { menu_name: name, menu_url: link.href });
    } else if (link.closest('.sf-footer__col ul, .footer-block__details-content')) {
      emit('footer_menu_click', { menu_name: name, menu_url: link.href });
    }
  }), { capture: true });
  safe(() => {
    if (config.page === 'product' && config.product) {
      const variant = config.product.variants.find(v => v.id === config.selectedVariant);
      if (variant) ecommerce('view_item', [item(config.product, variant, 1, productSource)]);
    }
    if (config.page === 'cart') ecommerce('view_cart', cartItems());
    if (config.search) emit('search', {
      search_term: config.search.term.toLocaleLowerCase('tr-TR'),
      search_results_count: config.search.count,
    });
  })();
})();
